import {
    MORE_1024_MEDIA_QUERY,
    MORE_440_MEDIA_QUERY,
    MORE_984_MEDIA_QUERY,
} from '../../../../consts/adaptive';


export const styles = {
    photoGallery: {
        position: 'relative',
        display: 'flex',
        padding: [0, 0, 16, 0],
        height: 'calc((100vw - 60px) / 1.8)',
        backgroundColor: '#e0f4ff',

        '& .content-loader': {
            position: 'absolute',
            top: 0,
            left: 0
        }
    },
    leftPhoto: {
        position: 'relative',
        width: '100%'
    },
    rightPhoto: {
        position: 'relative',
        display: 'none',
        width: '32%'
    },
    image: {
        display: 'block',
        opacity: 0
    },

    [MORE_440_MEDIA_QUERY]: {
        photoGallery: {
            height: 'calc((100vw - 90px) / 1.8)'
        },
    },

    [MORE_984_MEDIA_QUERY]: {
        photoGallery: {
            backgroundColor: '#fff'
        }
    },

    [MORE_1024_MEDIA_QUERY]: {
        photoGallery: {
            margin: 0,
            padding: 0,
            height: 465,
        },
        leftPhoto: {
            width: '67%',
            marginRight: 10
        },
        rightPhoto: {
            display: 'block'
        }
    }
};

export type ComponentJSSClasses = typeof styles;
